import * as tslib_1 from "tslib";
import { voteInPoll, voteInPollFail, voteInPollSuccess, } from './actionCreators';
import { select, call, all, put, takeLatest } from 'redux-saga/effects';
import { request } from '../../xhr';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import ddt from '@wix/da-ddt';
import { putEntities } from '../../redux/entities/actions';
import { normalize } from 'normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
var logger = ddt.createLogger('polls');
function fakeResponse(_a) {
    var _b = _a.data, pollid = _b.pollid, answerid = _b.answerid;
    logger.log('faking the response!');
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        var deviationsByType = require('@wix/da-sample-data').deviationsByType;
        var chance = require('chance');
        var poll = deviationsByType.polls.find(function (p) { return p.deviationId === pollid; }) ||
            chance.pickone(deviationsByType.polls);
        var answers = poll.poll.answers.slice();
        if (!answers.some(function (a) { return a.answerId === answerid; })) {
            answers[0] = tslib_1.__assign({}, answers[0], { answerId: answerid });
        }
        return {
            success: true,
            poll: tslib_1.__assign({}, poll, { deviationId: pollid, poll: tslib_1.__assign({}, poll.poll, { pollId: pollid, hasVoted: true, votedAnswerid: answerid, answers: answers }) }),
        };
    }
}
function handlePollVote(action) {
    var _a, pollid, answerid, userid, isLoggedIn, data, result, entities;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!action.payload) {
                    logger.error('Tried to vote in an invalid poll', action);
                    return [2 /*return*/];
                }
                _a = action.payload, pollid = _a.pollId, answerid = _a.answerId, userid = _a.userId;
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _b.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut())];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3:
                data = {
                    pollid: pollid,
                    answerid: answerid,
                    userid: userid,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/poll/vote',
                        data: data,
                    }, fakeResponse)];
            case 4:
                result = _b.sent();
                if (!(!result || !result.success)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(voteInPollFail(action.payload))];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6:
                entities = normalize(result.poll, deviationSchema).entities;
                return [4 /*yield*/, all([
                        put(voteInPollSuccess(tslib_1.__assign({}, action.payload, { poll: result.poll }))),
                        put(putEntities({ entities: entities })),
                    ])];
            case 7:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([takeLatest(voteInPoll, handlePollVote)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map